import * as React from "react";

const OrHrDivider = () => {
  return (
    <div className="or-hr-divider">
      <div className="or-hr-divider-text">או</div>
      <hr />
    </div>
  );
}

export default OrHrDivider;
